document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-size-system]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var system = this.getAttribute('data-size-system');
      var parent = this.closest('.rte') || this.closest('.disclosure__content') || this.closest('.content-tabs__panel');
      if (!parent) return;

      parent.querySelectorAll('[data-size-system]').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      parent.querySelectorAll('[data-size-panel]').forEach(function(p) {
        p.classList.remove('active');
      });
      var panel = parent.querySelector('[data-size-panel="' + system + '"]');
      if (panel) panel.classList.add('active');
    });
  });
});
